<template>
  <div class="modal" @mousedown.self="closePremiumModal">
    <div class="modal-dialog modal-dialog-lg">
      <div class="modal-content">
        <div class="modal-header mb-1 flex flex-end"><span class="modal-close" @click="closePremiumModal"><i class="icon-close"></i></span></div>
        <div class="row">
          <div class="col-md-6 order-2-xs">
            <PremiumFeatures/>
          </div>
          <div class="col-md-6">
            <div class="content-block-item -get-premium">
              <div class="modal-title p-0 mb-1 text-center">{{$lang.messages.get_premium_modal.choose_subscription}}</div>
              <div class="flex flex-wrap-xs">
                <label class="radio-wrapper -premium flex-wrap" :class="{active: premiumPlan === 'month'}">
                  <input name="premiumPlan" type="radio" class="radio-input" value="month" v-model="premiumPlan">
                  <span class="radio-check"></span>
                  <span class="radio-label">{{$lang.messages.get_premium_modal.monthly}}</span>
                  <span class="w-100"><span class="text-lg text-bold">$4.99 </span><span class="text-sm">{{$lang.messages.get_premium_modal.per_month}}</span></span>
                </label>
                <label class="radio-wrapper -premium flex-wrap" :class="{active: premiumPlan === 'year'}">
                  <input name="premiumPlan" type="radio" class="radio-input" value="year" v-model="premiumPlan">
                  <span class="radio-check"></span>
                  <span class="radio-label">{{$lang.messages.get_premium_modal.yearly}}</span>
                  <span class="premium-sale">{{$lang.messages.get_premium_modal.save_20}}</span>
                  <span class="w-100"><span class="text-lg text-bold">$4.08</span> <span class="text-sm">{{$lang.messages.get_premium_modal.per_month}}</span></span>
                </label>
              </div>
              <div class="flex flex-end">
                <div class="flex">
                  <svg width="52" height="25" viewBox="0 0 52 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M51 21C35.3333 26.1667 4 29.5 4 1.5M4 1.5L0.5 5.5M4 1.5L8 5.5" stroke="#9F81F8"/>
                  </svg>
                  <div class="premium-label-free">
                    <div class="text-thin">{{$lang.messages.get_premium_modal.get}}</div>
                    {{$lang.messages.get_premium_modal.two_month_free}}
                  </div>
                </div>
              </div>
              <div class="premium-total">
                <div class="w-100">
                  <div class="w-100 flex-between text-md mb-05">
                    <div>
                      {{$lang.messages.get_premium_modal.total_billed}} {{trialEndDate}}
                      <div class="premium-trial-label">
                        {{$lang.messages.get_premium_modal.will_remind}}
                      </div>
                    </div>
                    <div class="text-bold text-lg">
                      {{ premiumPlan === 'month' ? '$4.99' : '$49' }}
                    </div>
                  </div>
                  <div class="divider"></div>
                </div>
                <div class="premium-sale-total" v-if="premiumPlan !== 'month' && type === 'base'">{{$lang.messages.get_premium_modal.percent_off}}</div>
                <div class="w-100 flex-v-center flex-between text-bold">
                  <div class="text-lg">{{$lang.messages.get_premium_modal.total}}</div>
                  <div>
                    $0
                  </div>
                </div>
              </div>
              <Stripe :premiumPlan="premiumPlan" :customer="customer" :trial="true"
                      v-on:premiumispurchased = "premiumIsPurchased"
                      v-on:updatesettings = "updateSettings"/>
              <div class="premium-card-info">{{$lang.messages.get_premium_modal.card_text_info}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Stripe from "@/components/Stripe"
import {getMDY, getTimeStamp, reportEvent} from '../helpers/utils.js'
import PremiumFeatures from "@/components/PremiumFeatures";
export default {
  name: 'GetPremiumModal',
  props: {
    customer: Object,
    initialPremiumPlan: String,
  },
  data: function () {
    return {
      premiumPlan: this.$route.query.plan ? this.$route.query.plan : 'year',
      type: 'trial',
      trialEndDate: getMDY(new Date().getTime(), 7)
    }
  },
  methods: {
    premiumIsPurchased () {
      getTimeStamp((newTS) => {
        const today = new Date(newTS)
        let premiumEnd
        if(this.premiumPlan === 'month'){
          premiumEnd = today.setMonth(today.getMonth() + 1)
        } else {
          premiumEnd = today.setUTCFullYear(today.getUTCFullYear() + 1)
        }
        this.closePremiumModal()
        this.$emit('premiumispurchased');
        reportEvent('premiumispurchased');
        const newSet = {
          'premiumEnd': premiumEnd,
          'isPremium': true
        }
        this.updateSettings(newSet)
      })
    },
    closePremiumModal () {
      this.$emit('closepremiummodal');
    },
    updateSettings(settingsInObj){
      this.$emit('updatesettings', settingsInObj)
    }
  },
  components: {
    PremiumFeatures,
    Stripe
  }
}

</script>
<style lang="scss">
@import "../assets/styles/helpers";

.radio-wrapper.-premium {
  border: 1px solid #B2B4CF;
  align-items: flex-start;

  .radio-label {
    margin-bottom: 5px;
  }

  .radio-check {
    margin-top: 2px;
  }

  .premium-sale {
    font-size: 12px;
    background-color: #9F81F8;
    border-radius: 3px;
    padding: 3px;
    color: #fff;
    display: inline-block;
    margin-left: auto;
  }
}

.premium-sale-total {
  color: #9F81F8;
  width: 100%;
  font-size: 12px;
  text-align: right;
  display: block;
  font-weight: 400;
  position: absolute;
  top: 10px;
  right: 30px;
}

.premium {
  &-features-block {
    padding: 24px;
    @include responsive-below($xs){
      padding: 0 24px;
    }
  }
  &-title {
    font-size: 36px;
    margin-bottom: 50px;

    @include responsive-below($xs){
      margin-top: 30px;
      margin-bottom: 20px;
      text-align: center;
      font-size: 24px;
    }
  }

  &-feature {
    margin-bottom: 20px;

    &-icon {
      padding-top: 5px;
      margin-right: 20px;
    }

    &-text {
      font-weight: 600;
      color: #95959a;
      margin-right: 6px;

      &:before {
        content: "";
        display: inline-block;
        margin-right: 6px;
        width: 4px;
        height: 4px;
        background: #c4c4c4;
        border-radius: 50%;
        vertical-align: middle;
      }
    }
  }

  &-total {
    background: #FCFCFC;
    border-radius: 16px;
    padding: 24px 30px;
    font-size: 24px;
    margin: 14px 0 22px;
    position: relative;

    @include responsive-below($sm){
      margin-bottom: 0;
    }
  }

  &-card-info {
    color: #95959A;
    text-align: center;
    font-size: 12px;
    margin-top: 8px;
  }

  &-label-free {
    margin-left: 4px;
    font-size: 14px;
    line-height: 1;
    font-weight: 600;
    padding-top: 5px;
  }

  &-trial-label {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #95959a;
  }
}

.divider {
  border-top: 1px solid #F4F6F6;
  margin: 10px 0;
}

</style>
